import { Dispatch } from "react";
import { History } from "history";
import PropertyPageDispatcher from "@Pages/PropertyPage/data/actions";
import { getLink, getPropertyFilter } from "@Pages/Search/components/SearchListItem/helper";
import { runTasks } from "@Utils/performanceUtils";
import navigateTo from "@Utils/webApputils/navigateTo";

const handleRedirectToPropertyPage = ({
  dispatch,
  inventory,
  history,
  isDesktop,
  regionId,
  isDemoSubdomain,
  partner_uuid,
  redirectionLink = "",
  customWindowOpen,
}: {
  dispatch: Dispatch<any>;
  inventory: any;
  history: History<unknown>;
  regionId?: number;
  isDesktop: boolean;
  isDemoSubdomain: boolean;
  partner_uuid: string;
  redirectionLink?: string;
  customWindowOpen?: any;
}) => {
  const params = getPropertyFilter();
  const updatedParams: any = { ...params, ref: "search", ...(regionId && { regionId }) };
  if (isDemoSubdomain) {
    updatedParams["partner_id"] = partner_uuid;
  }

  const link = getLink(inventory, updatedParams);

  runTasks([
    isDesktop
      ? () => customWindowOpen?.({ url: redirectionLink || `${link}#room_type`, target: "_blank" })
      : () => navigateTo(history, redirectionLink || `${link}#room_type`, true),
    () => {
      // @ts-ignore
      const propertyPageDispatcher = new PropertyPageDispatcher(dispatch);
      propertyPageDispatcher.updateBasicDetails(inventory);
    },
  ]);
};

export default handleRedirectToPropertyPage;
